module.exports = __webpack_public_path__ + "img/fdbf60b.svg";